
type StreamMetricsData = {
  uniqueConnections: number;
  peakConnections: number;
  listeningTimeMinutes: number;
  listeningTimeHours: number;
  totalSessions: number;
  dailyAverageSessions: number;
  hourlyAverageSessions: number;
  averageSessionDuration: number;
}

export default class StreamMetrics {

  uniqueConnections: number;
  peakConnections: number;
  listeningTimeMinutes: number;
  listeningTimeHours: number;
  totalSessions: number;
  dailyAverageSessions: number;
  hourlyAverageSessions: number;
  averageSessionDuration: number;

  constructor(data: StreamMetricsData) {
    this.uniqueConnections = data.uniqueConnections;
    this.peakConnections = data.peakConnections;
    this.listeningTimeMinutes = data.listeningTimeMinutes;
    this.listeningTimeHours - data.listeningTimeHours;
    this.totalSessions = data.totalSessions;
    this.dailyAverageSessions = data.dailyAverageSessions;
    this.hourlyAverageSessions = data.hourlyAverageSessions;
    this.averageSessionDuration = data.averageSessionDuration;
  }

  static parse(data: any): StreamMetrics {
    return new StreamMetrics({
      uniqueConnections: data.uniqueConnections,
      peakConnections: data.peakConnections,
      listeningTimeMinutes: data.listeningTimeMinutes,
      listeningTimeHours: data.listeningTimeHours,
      totalSessions: data.totalSessions,
      dailyAverageSessions: data.dailyAverageSessions,
      hourlyAverageSessions: data.hourlyAverageSessions,
      averageSessionDuration: data.averageSessionDuration,
    });
  }

}



// WEBPACK FOOTER //
// ./src/statsradio/modules/streaming/domain/StreamMetrics.js